import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { ImCross } from "react-icons/im";
import { RiArrowDownSLine } from "react-icons/ri";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import wallet2 from "../../assets/images/wallet-add2.png";
import Setting from "components/svgs/Setting";
import SwapSettingsModal from "components/popup/Setting";

const NavBar = () => {
  const [isDaoOpen, setIsDaoOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-black mb-10 md:mb-20 text-white lg:px-16 px-4 py-4 lg:py-6">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <div className=" w-12 font-bold text-xl">
          <img src="/logo.png" className="w-12 h-12" alt="logo" />
        </div>

        {/* Nav Links - Hidden on small screens */}
        <div className="hidden md:flex space-x-8 text-sm font-medium">
          <a href="#" className="hover:text-[#C4FE48]">
            Trade
          </a>

          {/* DAO Dropdown */}
          {/* <div className="relative ">
            <button
              onClick={() => setIsDaoOpen(!isDaoOpen)}
              onBlur={() => setIsDaoOpen(false)}
              className="hover:text-[#C4FE48] flex items-center"
            >
              DAO{" "}
              <span>
                <RiArrowDownSLine size={20} />
              </span>
            </button>
            {isDaoOpen && (
              <div className="absolute w-36 top-full mt-2 bg-black border border-gray-700 rounded shadow-lg">
                <a
                  href="#"
                  className="block px-4 py-2 hover:bg-[#C4FE48] hover:text-black"
                >
                  Option 1
                </a>
                <a
                  href="#"
                  className="block px-4 py-2 hover:bg-[#C4FE48] hover:text-black"
                >
                  Option 2
                </a>
                <a
                  href="#"
                  className="block px-4 py-2 hover:bg-[#C4FE48] hover:text-black"
                >
                  Option 3
                </a>
              </div>
            )}
          </div>

          <a href="#" className="hover:text-[#C4FE48]">
            Earn
          </a> */}
          <a href="#" className="hover:text-[#C4FE48]">
            Bridges
          </a>
          <a href="#" className="hover:text-[#C4FE48]">
            Buy Crypto
          </a>
        </div>

        {/* Right-side Buttons */}
        <div className="flex space-x-2 gap-3 items-center">
          
          
          {/* //custome connect wallet modal */}
          <div className="hidden md:block">
          <ConnectButton.Custom>
            {({
              account,
              chain,
              openAccountModal,
              openChainModal,
              openConnectModal,
              mounted,
            }) => {
              const ready = mounted;
              const connected = ready && account && chain;

              return (
                <div
                  {...(!ready && {
                    "aria-hidden": true,
                    className: "opacity-0 pointer-events-none select-none",
                  })}
                >
                  {(() => {
                    if (!connected) {
                      return (
                        <button
                          onClick={openConnectModal}
                          type="button"
                          className="bg-[#C4FE48] cursor-pointer  hidden md:flex hover:bg-[#acdf3d] text-[#0C1101] px-4 py-2 rounded"
                        >
                          Connect Wallet
                          <span className="ml-1">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g opacity="0.4">
                                <path
                                  d="M14.2617 15.4385H9.26172"
                                  stroke="#0C1101"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M11.7617 12.998V17.998"
                                  stroke="#0C1101"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <path
                                d="M12.6601 2.51814L12.6301 2.58814L9.73008 9.31814H6.88008C6.20008 9.31814 5.55008 9.45814 4.96008 9.70814L6.71008 5.52814L6.75008 5.42814L6.82008 5.26814C6.84008 5.20814 6.86008 5.14814 6.89008 5.09814C8.20008 2.06814 9.68008 1.37814 12.6601 2.51814Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M18.05 9.51813C17.6 9.37813 17.12 9.31813 16.64 9.31813H9.72998L12.63 2.58813L12.66 2.51813C12.81 2.56813 12.95 2.63813 13.1 2.69813L15.31 3.62813C16.54 4.13813 17.4 4.66813 17.92 5.30813C18.02 5.42813 18.1 5.53813 18.17 5.66813C18.26 5.80813 18.33 5.94813 18.37 6.09813C18.41 6.18813 18.44 6.27813 18.46 6.35813C18.73 7.19813 18.57 8.22813 18.05 9.51813Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M21.5217 14.1984V16.1484C21.5217 16.3484 21.5117 16.5484 21.5017 16.7484C21.3117 20.2384 19.3617 21.9984 15.6617 21.9984H7.86172C7.62172 21.9984 7.38172 21.9784 7.15172 21.9484C3.97172 21.7384 2.27172 20.0384 2.06172 16.8584C2.03172 16.6284 2.01172 16.3884 2.01172 16.1484V14.1984C2.01172 12.1884 3.23172 10.4584 4.97172 9.70836C5.57172 9.45836 6.21172 9.31836 6.89172 9.31836H16.6517C17.1417 9.31836 17.6217 9.38836 18.0617 9.51836C20.0517 10.1284 21.5217 11.9884 21.5217 14.1984Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                opacity="0.4"
                                d="M6.71 5.52814L4.96 9.70814C3.22 10.4581 2 12.1881 2 14.1981V11.2681C2 8.42814 4.02 6.05814 6.71 5.52814Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                opacity="0.4"
                                d="M21.5186 11.2677V14.1977C21.5186 11.9977 20.0586 10.1277 18.0586 9.52766C18.5786 8.22766 18.7286 7.20766 18.4786 6.35766C18.4586 6.26766 18.4286 6.17766 18.3886 6.09766C20.2486 7.05766 21.5186 9.02766 21.5186 11.2677Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </button>
                      );
                    }

                    if (chain.unsupported) {
                      return (
                        <button
                          onClick={openChainModal}
                          type="button"
                          className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
                        >
                          Wrong network
                        </button>
                      );
                    }

                    return (
                      <div className="flex gap-3">
                        <button
                          onClick={openChainModal}
                          type="button"
                          className="flex items-center bg-[#383937] hover:bg-gray-700 text-white py-2 px-4 rounded "
                        >
                          {chain.hasIcon && (
                            <div
                              className="bg-white w-3 h-3 rounded-full overflow-hidden mr-2"
                              style={{ background: chain.iconBackground }}
                            >
                              {chain.iconUrl && (
                                <img
                                  alt={chain.name ?? "Chain icon"}
                                  src={chain.iconUrl}
                                  className="w-3 h-3"
                                />
                              )} 
                            </div>
                          )}
                          {chain.name}
                        </button>
                        <button
                          onClick={openAccountModal}
                          type="button"
                          className="hover:bg-[#acdf3d] bg-[#C4FE48] text-black py-2 px-4 rounded "
                        >
                          {account.displayName}
                          {account.displayBalance
                            ? ` (${account.displayBalance})`
                            : ""}
                        </button>
                      </div>
                    );
                  })()}
                </div>
              );
            }}
          </ConnectButton.Custom>
          </div>
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-gray-500 md:hidden"
          >
            {isMenuOpen ? <ImCross size={20} /> : <GiHamburgerMenu size={20} />}
          </button>
          <button 
          onClick={() => setIsOpen(!isOpen)}
          className="rounded-lg cursor-pointer border border-[#383937] p-[10px]">
          
            <Setting  />

          </button>
          <div className="h-0 w-0">
          {
            isOpen && <SwapSettingsModal isOpen={isOpen} setIsOpen={setIsOpen} />
          }
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden mt-2">
          <div className="flex flex-col space-y-2 text-sm font-medium gap-4 justify-center items-center">
            <a href="#" className="hover:text-green-400">
              Trade
            </a>

            {/* DAO Dropdown for Mobile */}
            {/* <div className="relative ">
              <button
                onClick={() => setIsDaoOpen(!isDaoOpen)}
                className="hover:text-[#C4FE48]"
              >
                DAO
              </button>
              {isDaoOpen && (
                <div className="mt-2 bg-black border border-gray-700 rounded shadow-lg">
                  <a href="#" className="block px-4 py-2 hover:bg-[#C4FE48]">
                    Option 1
                  </a>
                  <a href="#" className="block px-4 py-2 hover:bg-[#C4FE48]">
                    Option 2
                  </a>
                  <a href="#" className="block px-4 py-2 hover:bg-[#C4FE48]">
                    Option 3
                  </a>
                </div>
              )}
            </div>

            <a href="#" className="hover:text-[#C4FE48]">
              Earn
            </a> */}
            <a href="#" className="hover:text-[#C4FE48]">
              Bridges
            </a>
            <a href="#" className="hover:text-[#C4FE48]">
              Buy Crypto
            </a>
            <div className="block md:hidden">
          <ConnectButton.Custom>
            {({
              account,
              chain,
              openAccountModal,
              openChainModal,
              openConnectModal,
              mounted,
            }) => {
              const ready = mounted;
              const connected = ready && account && chain;

              return (
                <div
                  {...(!ready && {
                    "aria-hidden": true,
                    className: "opacity-0 pointer-events-none select-none",
                  })}
                >
                  {(() => {
                    if (!connected) {
                      return (
                        <button
                          onClick={openConnectModal}
                          type="button"
                          className="bg-[#C4FE48] cursor-pointer   flex hover:bg-[#acdf3d] text-[#0C1101] px-4 py-2 rounded"
                        >
                          Connect Wallet
                          <span className="ml-1">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g opacity="0.4">
                                <path
                                  d="M14.2617 15.4385H9.26172"
                                  stroke="#0C1101"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M11.7617 12.998V17.998"
                                  stroke="#0C1101"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <path
                                d="M12.6601 2.51814L12.6301 2.58814L9.73008 9.31814H6.88008C6.20008 9.31814 5.55008 9.45814 4.96008 9.70814L6.71008 5.52814L6.75008 5.42814L6.82008 5.26814C6.84008 5.20814 6.86008 5.14814 6.89008 5.09814C8.20008 2.06814 9.68008 1.37814 12.6601 2.51814Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M18.05 9.51813C17.6 9.37813 17.12 9.31813 16.64 9.31813H9.72998L12.63 2.58813L12.66 2.51813C12.81 2.56813 12.95 2.63813 13.1 2.69813L15.31 3.62813C16.54 4.13813 17.4 4.66813 17.92 5.30813C18.02 5.42813 18.1 5.53813 18.17 5.66813C18.26 5.80813 18.33 5.94813 18.37 6.09813C18.41 6.18813 18.44 6.27813 18.46 6.35813C18.73 7.19813 18.57 8.22813 18.05 9.51813Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M21.5217 14.1984V16.1484C21.5217 16.3484 21.5117 16.5484 21.5017 16.7484C21.3117 20.2384 19.3617 21.9984 15.6617 21.9984H7.86172C7.62172 21.9984 7.38172 21.9784 7.15172 21.9484C3.97172 21.7384 2.27172 20.0384 2.06172 16.8584C2.03172 16.6284 2.01172 16.3884 2.01172 16.1484V14.1984C2.01172 12.1884 3.23172 10.4584 4.97172 9.70836C5.57172 9.45836 6.21172 9.31836 6.89172 9.31836H16.6517C17.1417 9.31836 17.6217 9.38836 18.0617 9.51836C20.0517 10.1284 21.5217 11.9884 21.5217 14.1984Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                opacity="0.4"
                                d="M6.71 5.52814L4.96 9.70814C3.22 10.4581 2 12.1881 2 14.1981V11.2681C2 8.42814 4.02 6.05814 6.71 5.52814Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                opacity="0.4"
                                d="M21.5186 11.2677V14.1977C21.5186 11.9977 20.0586 10.1277 18.0586 9.52766C18.5786 8.22766 18.7286 7.20766 18.4786 6.35766C18.4586 6.26766 18.4286 6.17766 18.3886 6.09766C20.2486 7.05766 21.5186 9.02766 21.5186 11.2677Z"
                                stroke="#0C1101"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </button>
                      );
                    }

                    if (chain.unsupported) {
                      return (
                        <button
                          onClick={openChainModal}
                          type="button"
                          className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
                        >
                          Wrong network
                        </button>
                      );
                    }

                    return (
                      <div className="flex flex-col gap-3">
                        <button
                          onClick={openChainModal}
                          type="button"
                          className="flex items-center bg-[#383937] hover:bg-gray-700 text-white py-2 px-4 rounded "
                        >
                          {chain.hasIcon && (
                            <div
                              className="bg-white w-3 h-3 rounded-full overflow-hidden mr-2"
                              style={{ background: chain.iconBackground }}
                            >
                              {chain.iconUrl && (
                                <img
                                  alt={chain.name ?? "Chain icon"}
                                  src={chain.iconUrl}
                                  className="w-3 h-3"
                                />
                              )} 
                            </div>
                          )}
                          {chain.name}
                        </button>
                        <button
                          onClick={openAccountModal}
                          type="button"
                          className="hover:bg-[#acdf3d] bg-[#C4FE48] text-black py-2 px-4 rounded "
                        >
                          {account.displayName}
                          {account.displayBalance
                            ? ` (${account.displayBalance})`
                            : ""}
                        </button>
                      </div>
                    );
                  })()}
                </div>
              );
            }}
          </ConnectButton.Custom>
          </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
